/**
 * Put-away Redux slice (PutAwayV2)
 *
 * Owns the shared loading flag for the put-away worklist. The list fetch,
 * target resolution, and move thunks flip it; the lightweight location
 * search/validate lookups intentionally do not (they back inline dropdowns).
 */
import { createSlice } from '@reduxjs/toolkit';
import { fetchPutAwayCandidates, movePutAway, resolvePutAwayTarget } from './putawayThunks';
var initialState = {
    isLoading: false
};
export var putawaySlice = createSlice({
    name: 'putaway',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchPutAwayCandidates.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(fetchPutAwayCandidates.fulfilled, function (state) {
            state.isLoading = false;
        })
            .addCase(fetchPutAwayCandidates.rejected, function (state) {
            state.isLoading = false;
        })
            .addCase(resolvePutAwayTarget.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(resolvePutAwayTarget.fulfilled, function (state) {
            state.isLoading = false;
        })
            .addCase(resolvePutAwayTarget.rejected, function (state) {
            state.isLoading = false;
        })
            .addCase(movePutAway.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(movePutAway.fulfilled, function (state) {
            state.isLoading = false;
        })
            .addCase(movePutAway.rejected, function (state) {
            state.isLoading = false;
        });
    }
});
export default putawaySlice.reducer;
